import { hourMs } from "verdi-common/timeConstants";
import type { TimeEvent } from "../../band-data/types";
import { toBandRows } from "./build-band-options";

/** Time covered by the events inside the window. A running event counts up to now. */
export function totalMs(events: TimeEvent[], window: { startMs: number; endMs: number }, nowMs: number): number {
    return toBandRows(events, window, nowMs).reduce((sum, [startMs, endMs]) => sum + endMs - startMs, 0);
}

/** "14.4h", "0.5h", "0h". */
export function formatHours(ms: number): string {
    return `${Math.round((ms / hourMs) * 10) / 10}h`;
}
